module.exports = __webpack_public_path__ + "static/img/3ban.6acda1a6.png";